import { BASE_END_POINT } from "../../parametros";
import i18n from "i18next";
import { ComunidadeDTO } from "../dtos/ComunidadeDTO";

async function buscarComunidades(): Promise<ComunidadeDTO> {

    const url = `${BASE_END_POINT}/api-v1/comum-site/comunidades`;

    const response = await fetch(url, {
        headers: { 'Accept-Language': i18n.language }
    });

    if (!response.ok) {
        throw new Error(`Erro ao buscar comunidades. Código: ${response.status}`);
    }

    return await response.json() as ComunidadeDTO;
}

function armazenarComunidadesSession(comunidade: ComunidadeDTO): void {
    window.sessionStorage.setItem('comunidades', JSON.stringify(comunidade));
}

function obterComunidadesSession(): ComunidadeDTO {
    return JSON.parse(window.sessionStorage.getItem('comunidades')!) as ComunidadeDTO;
}

export {
    buscarComunidades,
    armazenarComunidadesSession,
    obterComunidadesSession,
}